<script setup lang="ts">
import { IconReactionSmileFill } from "@packages/icon-library";
import { usePlaceStore } from "@/modules/place-module";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

const placeStore = usePlaceStore();
const place = computed(() => placeStore.place?.place);
const router = useRouter();

const { t } = useI18n();

const savePagePosition = () => {
  localStorage.setItem(
    "lastVisitPage",
    `${window.location.pathname}${window.location.search}`
  );

  let promoCode = "";

  if (place.value?.registration_url.includes("/r/")) {
    promoCode = place.value?.registration_url.split("/r/")[1];
  }

  if (promoCode) {
    router.push(`/r/${promoCode}`);
    return;
  }

  window.location.href = place.value?.registration_url;
};
</script>

<template>
  <section class="place-auth-banner">
    <div class="auth-banner">
      <IconReactionSmileFill />
      <p>
        {{ t("place.authBanner.text") }}
        <button type="button" @click="savePagePosition">
          {{ t("place.authBanner.link") }}
        </button>
      </p>
    </div>
  </section>
</template>

<style scoped lang="scss">
.place-auth-banner {
  padding: 24px 32px;
  border-top: 1px solid var(--color-semantic-border-normal-soft);

  @media (width < 1024px) {
    padding: 24px;
  }

  @media (width < 768px) {
    padding: 20px 16px;
  }
}

.auth-banner {
  border-radius: 12px;
  background: var(--color-non-semantic-background-soft-blue);
  padding: 16px;
  display: grid;
  grid-template-columns: 24px 1fr;
  align-items: center;
  gap: 12px;

  > .icon {
    width: 24px;
    height: 24px;
    background-color: var(--color-semantic-content-normal-info);
  }

  > p {
    color: var(--color-semantic-content-normal-secondary);
    @include body-s();

    > button {
      color: var(--color-semantic-content-normal-link);
      @include body-bold-s();
    }
  }
}
</style>
